"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const orderstatusbrand01 = _ref => {
  let {
    title,
    description,
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("svg", _extends({}, props, {
    viewBox: "0 0 67 70",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": (title ? `title-orderstatusbrand01` : '') + (description ? ` desc-orderstatusbrand01` : '') || undefined,
    role: "img"
  }), title && /*#__PURE__*/_react.default.createElement("title", {
    id: "title-orderstatusbrand01"
  }, title), description && /*#__PURE__*/_react.default.createElement("desc", {
    id: "desc-orderstatusbrand01"
  }, description), /*#__PURE__*/_react.default.createElement("g", {
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M39.453 69.539a3.81 3.81 0 0 1-3.416.11L7.71 56.647c-1.499-.687-2.472-2.27-2.472-4.023V22.937c0-1.698.915-3.243 2.346-3.961L34.142 5.647a3.807 3.807 0 0 1 3.23-.096l26.305 11.317c1.544.663 2.557 2.27 2.558 4.058v31.506c-.001 1.656-.872 3.17-2.249 3.91L39.453 69.539Z",
    fill: "#FFC599",
    fillOpacity: ".5"
  }), /*#__PURE__*/_react.default.createElement("g", {
    fill: "#F26B1C"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M32.528 29.032a1 1 0 0 1 1-1h.004a1 1 0 1 1 0 2h-.004a1 1 0 0 1-1-1Z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M30.353 2.303a2.807 2.807 0 0 1 2.385-.071l-2.385.071Zm0 0L3.795 15.631C2.727 16.168 2 17.351 2 18.7v29.687c0 1.393.773 2.602 1.889 3.114l28.327 13a2.81 2.81 0 0 0 2.526-.081l24.532-13.197c1.03-.554 1.722-1.715 1.723-3.03V16.69c-.001-1.422-.806-2.647-1.953-3.14L32.738 2.232m.79-1.838a4.806 4.806 0 0 0-4.072.121L2.898 13.844C1.104 14.744 0 16.65 0 18.7v29.687c0 2.112 1.173 4.069 3.055 4.931l28.327 13a4.81 4.81 0 0 0 4.306-.136l24.533-13.198c1.725-.926 2.775-2.792 2.776-4.79V16.689c-.002-2.154-1.223-4.143-3.163-4.977L33.528.394Z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M62.113 13.665a1 1 0 0 1-.407 1.354l-27.7 14.894a1 1 0 1 1-.948-1.761l27.7-14.894a1 1 0 0 1 1.355.407Z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M.796 15.833a1 1 0 0 1 1.302-.553L33.9 28.105a1 1 0 0 1 .626.928V65.75a1 1 0 1 1-2 0V29.707L1.35 17.134a1 1 0 0 1-.554-1.301ZM15.736 7.645a1 1 0 0 1 1.328-.488L47.09 21.058a1 1 0 1 1-.84 1.815l-30.026-13.9a1 1 0 0 1-.488-1.328Z"
  }))));
};
var _default = exports.default = orderstatusbrand01;